<div class="contract-alerts">
  <div class="section-head section-head--stacked">
    <div class="section-copy">
      <div class="section-copy__topline">
        <h2>{{ 'ADMIN_DASHBOARD.CONTRACT_ALERTS.TITLE' | translate }}</h2>
      </div>
      <p>{{ 'ADMIN_DASHBOARD.CONTRACT_ALERTS.SUBTITLE' | translate }}</p>
    </div>
  </div>

  <nz-skeleton *ngIf="loading" [nzActive]="true"></nz-skeleton>

  <nz-empty
    *ngIf="!loading && !items.length"
    [nzNotFoundContent]="'ADMIN_DASHBOARD.CONTRACT_ALERTS.EMPTY' | translate">
  </nz-empty>

  <div class="alerts-list" *ngIf="!loading && items.length">
    <nz-card class="alert-card" *ngFor="let item of items">
      <div class="alert-card__head">
        <div>
          <div class="alert-card__company">{{ item.companyName }}</div>
          <div class="alert-card__meta">
            <span>{{ planText(item.plan) }}</span>
            <span *ngIf="item.date">{{ formatDate(item.date) }}</span>
          </div>
        </div>
        <nz-tag [nzColor]="statusColor(item.status)">
          {{ ('ADMIN_DASHBOARD.CONTRACT_TIMELINE.STATUS.' + item.status.toUpperCase()) | translate }}
        </nz-tag>
      </div>

      <div class="alert-card__body">
        {{ alertText(item) }}
      </div>

      <div class="alert-card__actions">
        <button nz-button nzType="link" type="button" (click)="openCompany.emit(item.companyId)">
          {{ 'ADMIN_DASHBOARD.DRAWER.TITLE' | translate }}
        </button>
      </div>
    </nz-card>
  </div>
</div>
